exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3yPsiEJZahbdLDyBSjz9fL {\n  padding: 8px;\n  margin: -8px;\n  margin-right: 8px;\n  border-top-left-radius: 5px;\n  display: flex;\n  align-items: center;\n  border-right: 2px solid #ebecf0;\n}\n._3yPsiEJZahbdLDyBSjz9fL ._2P4-3XRrQZHnZ5jMgvmbsE {\n  padding-right: 8px;\n  font-size: 1.18rem;\n}\n._2YdVKQYLgCZ9ARwC73EIAt._2YdVKQYLgCZ9ARwC73EIAt._2YdVKQYLgCZ9ARwC73EIAt {\n  margin-right: 8px;\n}\n", ""]);
// Exports
exports.locals = {
	"modeContainer": "_3yPsiEJZahbdLDyBSjz9fL",
	"title": "_2P4-3XRrQZHnZ5jMgvmbsE",
	"button": "_2YdVKQYLgCZ9ARwC73EIAt"
};